// extracted by mini-css-extract-plugin
export default {"projectPage":"Projects_projectPage__t3yWw","header":"Projects_header__qB7ET","projectGrid":"Projects_projectGrid__GwxPY","projectCard":"Projects_projectCard__lZnac"};